/**
 * Remove all letters from a string.
 * @param {string} string The string to remove letters from
 * @returns {string} The string with all letters removed
 */
export function excludeLettersFromString(string?: string): string {
  if (!string) return '';
  return string.replace(/\D/g, '');
}
